module.exports = __webpack_public_path__ + "img/23.94f82597.jpg";